import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import TaskPopUp from "../Popup/TaskPopUp";
import axios from "axios";
import ReceePrintPage from "../Popup/ReceePrintPage";

const SharedTask = () => {
    let {taskToken} =  useParams();
    const [taskData, setTaskData] = useState([])
    const [printData, setPrintData] = useState(false)


    const getTaskData = async () => {
        let bUrl = `/task/sharedTask/${taskToken}`

        await axios.get(bUrl)
            .then(async (response) => {
                // Handle the response here
                // await setTasksData(response.data.message);
                await setTaskData(response.data.data);
                console.log('Response:', response);

                setTimeout(() => {
                    window.print();
                }, 800)
            })
            .catch((error) => {
                // Handle errors here
                console.error('Error:', error);
            });
    }

    useEffect(() => {
        getTaskData().then(r => {
            setPrintData(true)
            console.log("done task")
        })
    }, [])

    return (
        <>
            {taskData?.length > 0
                ?<ReceePrintPage recceData={taskData}/>
                : <>Loading Data</>
            }
        </>

    )
}


export default SharedTask;
